export default "__VITE_ASSET__aMcQDbnv__"